<app-modal-frame
  [headerText]="
    data.operationType === OPERATION_TYPES.ARRIVE
      ? CONSTANTS.ARRIVE_HEADER
      : CONSTANTS.DEPART_HEADER
  "
  (emitExit)="onExit()"
>
  <form [formGroup]="keyEntryForm">
    <ion-row class="ion-justify-content-between">
      <!-- Origin CC -->
      <ion-col
        size="auto"
        [class.disabled-control]="data.operationType === OPERATION_TYPES.DEPART"
      >
        <app-form-text-field
          [labelText]="CONSTANTS.LABELS.ORIGIN_CC"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.ORIGIN_CC"
          [isRequiredSignForDisabled]="true"
          [maxLength]="2"
        ></app-form-text-field>
      </ion-col>

      <!-- Origin SLIC -->
      <ion-col
        size="auto"
        [class.disabled-control]="data.operationType === OPERATION_TYPES.DEPART"
      >
        <app-form-text-field
          [labelText]="CONSTANTS.LABELS.ORIGIN_SLIC"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.ORIGIN_SLIC"
          [isRequiredSignForDisabled]="true"
          [maxLength]="5"
        ></app-form-text-field>
      </ion-col>

      <!-- Origin Sort -->
      <ion-col size="auto">
        <app-form-select
          [label]="CONSTANTS.LABELS.ORIGIN_SORT"
          [options]="sortOptions"
          [formControlName]="FORM_CONTROLS.ORIGIN_SORT"
          [required]="true"
        >
        </app-form-select>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-between">
      <!-- Destination CC -->
      <ion-col
        size="auto"
        [class.disabled-control]="data.operationType === OPERATION_TYPES.ARRIVE"
      >
        <app-form-text-field
          [labelText]="CONSTANTS.LABELS.DESTINATION_CC"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.DESTINATION_CC"
          [isRequiredSignForDisabled]="true"
          [maxLength]="2"
        ></app-form-text-field>
      </ion-col>

      <!-- Destination SLIC -->
      <ion-col
        size="auto"
        [class.disabled-control]="data.operationType === OPERATION_TYPES.ARRIVE"
      >
        <app-form-text-field
          [labelText]="CONSTANTS.LABELS.DESTINATION_SLIC"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.DESTINATION_SLIC"
          [isRequiredSignForDisabled]="true"
          [maxLength]="5"
        ></app-form-text-field>
      </ion-col>

      <!-- Destination Sort -->
      <ion-col size="auto">
        <app-form-select
          [label]="CONSTANTS.LABELS.DESTINATION_SORT"
          [options]="sortOptions"
          [formControlName]="FORM_CONTROLS.DESTINATION_SORT"
          [required]="true"
        >
        </app-form-select>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-between">
      <!-- Equipment Number -->
      <ion-col size="auto">
        <app-form-text-field
          [labelText]="CONSTANTS.LABELS.EQUIPMENT_NUMBER"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.EQUIPMENT_NUMBER"
          [maxLength]="12"
        ></app-form-text-field>
      </ion-col>

      <!-- Equipment Type -->
      <ion-col size="auto">
        <app-form-select
          [label]="CONSTANTS.LABELS.EQUIPMENT_TYPE"
          [options]="equipmentTypeOptions"
          [formControlName]="FORM_CONTROLS.EQUIPMENT_TYPE"
          [required]="true"
        >
        </app-form-select>
      </ion-col>

      <!-- Sort Date -->
      <ion-col size="auto">
        <span class="sort-date">{{ CONSTANTS.LABELS.SORT_DATE }}</span>
        <app-form-date-picker
          [formControlName]="FORM_CONTROLS.SORT_DATE"
          [maxDate]="maxDate"
          [minDate]="minDate"
          [icon]="calendarIcon"
          [required]="true"
          iconWidth="20px"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Load Service Level -->
      <ion-col size="auto" class="pr-16">
        <app-form-select
          [label]="CONSTANTS.LABELS.LOAD_SERVICE_LEVEL"
          [options]="loadServiceLevelOptions"
          [formControlName]="FORM_CONTROLS.LOAD_SERVICE_LEVEL"
          [required]="true"
          [isAppendToBody]="true"
        >
        </app-form-select>
      </ion-col>

      <!-- Arrival Time -->
      <ion-col size="auto" class="pl-20">
        <app-form-time-picker
          [headerText]="
            data.operationType === OPERATION_TYPES.DEPART
              ? CONSTANTS.LABELS.DEPART_TIME
              : CONSTANTS.LABELS.ARRIVAL_TIME
          "
          [defaultStartTime]="defaultStartTime"
          [form]="keyEntryForm"
          [control]="FORM_CONTROLS.TIME"
          [required]="true"
        ></app-form-time-picker>
      </ion-col>
    </ion-row>

    <div class="footer">
      <ion-row>
        <ion-col class="reset">
          <ion-button
            fill="outline"
            class="reset-btn"
            [disabled]="!keyEntryForm.dirty"
            (click)="resetForm()"
          >
            <span>{{ CONSTANTS.RESET }}</span>
          </ion-button>
        </ion-col>
        <ion-col class="submit">
          <ion-button
            class="submit-btn"
            (click)="submit()"
            [disabled]="keyEntryForm.invalid"
          >
            <span>{{
              data.operationType === OPERATION_TYPES.DEPART
                ? CONSTANTS.DEPART_HEADER
                : CONSTANTS.ARRIVE_HEADER
            }}</span>
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </form>
</app-modal-frame>
